export const SECTIONS = {
    MIDDLE: 'middle',
    BOTTOM: 'bottom',
};
